import AdminReportsPage from "./AdminReportsPage";

export default AdminReportsPage;
